export default __webpack_public_path__ + "static/partnerColorIcon5-e5bdf2b34e4d3a99d4becc10de8f32d1.svg";